export const ROLES = {
  ADMINISTRATIVO: "administrativo",
  AGENCIA: "agencia",
  BOARD: "board",
  CLIENTE: "cliente",
  COMERCIAL: "comercial",
  CONTABLE: "contable",
  EDIFICIO: "edificio",
  GERENCIA: "gerencia",
  INFRAESTRUCTURA: "infraestructura",
  INVERSOR: "inversor",
  SUPERADMIN: "superadmin",
};
